<template>
  <IQOS :title="'Вартість доставки'">
    <div class="partner-conditions">
      <p class="title">
        Тариф за доставку розраховується згідно Ваших домовленостей з партнером DELIVERY.
        Поточний тариф:
        <span
          class="partner-price"
        >+ {{cafe.delivery.taxi_cost}} грн</span> до кожного замовлення і
        <span class="partner-price">{{cafe.delivery.taxi_percent}}%</span> від вартості кожного замовлення
        <br>
        Мінімальна сума чеку: <span class="partner-price">199 грн</span>
      </p>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

export default {
  components: {
    IQOS
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  }
};
</script>

<style scoped>
.partner-conditions {
  color: #ededed;
  margin-top: 0;
}

.partner-price {
  border-radius: 1vw;
  border: 1px solid #ededed;
  padding: 0.2vw 0.7vh;
  display: inline-block;
}
</style>